export const appVersion = '1.36.3';
